import {SearchWithCameraScanCommandHandler} from './search-with-camera-scan.command-handler';
import {DomainCommand} from '../../modules/command-bus/command';

export class SearchWithCameraScanCommand extends DomainCommand {
  constructor(id: number, timestamp: number) {
    super(SearchWithCameraScanCommandHandler, {id, timestamp});
  }
}
